import Price from 'snippets/price/price'

function PriceCompare({
  price,
  customPrice,
  className = '',
  classPrice = '',
  classCustomPrice = '',
  classLabel = '',
  priceLabel = '',
  customPriceLabel = ''
}) {
  return (
    <div className={`flex ${className}`}>
      <div className="flex-1 text-center">
        <Price price={price} classSize={classPrice} />
        <span className={classLabel}>{priceLabel}</span>
      </div>
      <div className="flex-1 text-center">
        <Price price={customPrice} classSize={classCustomPrice} />
        <span className={classLabel}>{customPriceLabel}</span>
      </div>
    </div>
  )
}

export default PriceCompare
